<template>
  <div class="virtualPrivateCloudResourceAzureSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:azure:virtualPrivateCloudResourceAzure:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableVirtualPrivateCloudResourceAzure from "../vpc/TableVirtualPrivateCloudResourceAzure";
var tableVirtualPrivateCloudResourceAzure = TableVirtualPrivateCloudResourceAzure;
export default {
  name: "VirtualPrivateCloudResourceAzureSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: []
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      tableVirtualPrivateCloudResourceAzure.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.virtualPrivateCloudResourceAzureSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/vpc/VirtualPrivateCloudResourceAzureSearch.vue